'use client';
import { type ReactNode, useEffect, useState } from 'react';
import { Button } from 'components/UI/Button';
import { useTrackingRegistry } from 'context/TrackingContext';

type ReadMoreSectionProps = {
  buttonId: string; // für aria-controls
  children: ReactNode;
};

export const ReadMoreSection = ({ buttonId, children }: ReadMoreSectionProps) => {
  const [open, setOpen] = useState(false);
  const { register, unregister } = useTrackingRegistry();

  useEffect(() => {
    register('readMore');
    return () => {
      unregister('readMore');
    };
  }, [register, unregister]);

  const onClick = () => {
    register('readMoreClicked');
    setOpen(true);
  };

  return (
    <>
      {!open && (
        <Button variant="readMore" aria-expanded={open} aria-controls={buttonId} onClick={onClick}>
          Hier weiterlesen
        </Button>
      )}

      <div id={buttonId} hidden={!open}>
        {children}
      </div>
    </>
  );
};
